import React from 'react'
import { Item, ItemGif, ItemText } from './sc'

type Props = {
    displayName: string
    backgroundText: string | undefined
    onClick: () => void
}

const AddToButton = ({ displayName, onClick, backgroundText }: Props) =>
    displayName ? (
        <Item onClick={onClick} gutter>
            <ItemGif src="https://media.giphy.com/media/fTytsfKCVyb6lB75jM/giphy.gif" alt="New collection" />
            <ItemText background={backgroundText || ''}>{displayName}</ItemText>
        </Item>
    ) : null

export default AddToButton
